import Aos from 'aos'
import { useEffect } from 'react'
import Image2 from '../../assests/airobot.png'
import Image3 from '../../assests/robot.png'
import Image1 from '../../assests/robott.png'
import './Services.css'

const data = [
  {
    id: 1,
    image: Image1,
    title: 'Web developer',
    description:
      'My aim is to bring across your message and identiful in the most creative way. I have acquired the skills and knowledge necessary to make your project a success. ',
  },
  {
    id: 2,
    image: Image2,
    title: 'E-Commerce website',
    description:
      'My aim is to bring across your message and identiful in the most creative way. I have acquired the skills and knowledge necessary to make your project a success. ',
  },

  {
    id: 3,
    image: Image3,
    title: 'Grafic Design',
    description:
      'My aim is to bring across your message and identiful in the most creative way. I have acquired the skills and knowledge necessary to make your project a success. ',
  },
]

const Services = () => {
  useEffect(() => {
    Aos.init({
      duration: 2000,
      once: false,
    })

    // Add this line to refresh AOS on each re-render
    Aos.refresh()

    // Cleanup function
    return () => {
      Aos.refresh()
    }
  }, [])
  return (
    <section className="services container section" id="services">
      <h2 data-aos="fade-up" className="section__title">
        Services
      </h2>

      <div className="services__container grid">
        {data.map(({ id, image, title, description }) => {
          return (
            <div data-aos="zoom-in" className="services__card" key={id}>
              <img src={image} alt="" className="services__img" />

              <h3 className="services__title">{title}</h3>
              <p className="services__description">{description}</p>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default Services
